/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export const SVG_NAMESPACE = 'svg';
export const MATH_ML_NAMESPACE = 'math';
